import styled from 'styled-components';
import Image from 'next/image';
import { TypeBodyLarge, TypeBodyLargeStrong } from '../Typography';
import Label from '../Label';
import { mqLargeMin } from 'styled/tools/media-queries';

export const ProductCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--fill-secondary);
  border-radius: var(--radius-xl);
  padding: var(--spacing-16);
  gap: var(--spacing-16);

  @media ${mqLargeMin} {
    flex-direction: row-reverse;
  }
`;
export const ProductImageContainer = styled.div`
  position: relative;
  background: var(--fill-tertiary);
  border-radius: var(--radius-md);

  width: auto;
  height: 325px;

  &.capsule-image {
    display: none;
  }

  @media ${mqLargeMin} {
    width: 418px;
    height: 418px;

    &.capsule-image {
      display: flex;
    }
  }
`;
export const ProductCardLabel = styled(Label)`
  position: absolute;
  top: var(--spacing-8);
  left: var(--spacing-8);
  width: max-content;
`;
export const ProductImage = styled(Image)`
  border-radius: var(--radius-md);
  object-fit: contain;
  margin: auto;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-24);

  @media ${mqLargeMin} {
    flex: 1 0 0;
    margin: auto;
    padding: 0 var(--spacing-16);
    min-width: 344px;
  }
`;

export const ProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
`;
export const ProductHeaderContainer = styled.div`
  display: flex;
  gap: var(--spacing-8);
  align-items: center;

  @media ${mqLargeMin} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ProductPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);

  & > span {
    width: fit-content;
  }
`;
export const PriceDetailsContainer = styled.div`
  display: flex;
  gap: 4px;
`;
export const CrossedOutPrice = styled(TypeBodyLarge)`
  color: var(--text-disabled);
  text-decoration: line-through;
`;
export const ActionContainer = styled.div`
  display: flex;
  gap: var(--spacing-32);
  padding-right: var(--spacing-24);

  @media ${mqLargeMin} {
    gap: var(--spacing-24);
    padding-right: 0;
  }
  > a {
    flex-grow: 1;

    @media ${mqLargeMin} {
      flex-grow: 0;
      width: 200px;
    }
  }
`;
export const LearnMore = styled(TypeBodyLargeStrong)`
  font-size: var(--spacing-16);
  text-decoration: underline;
  align-self: center;
  text-underline-offset: var(--spacing-8);
  cursor: pointer;
`;
export const ProductName = styled.h2``;
